"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTracingHeader = addTracingHeader;
exports.isRequestOriginEnabled = isRequestOriginEnabled;
exports.updateLocationInformationOnApiOriginRequest = updateLocationInformationOnApiOriginRequest;
const log_1 = require("@aurora/shared-utils/log");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const log = (0, log_1.getLog)(module);
const requestOriginHeader = 'kh-api-request-origin-info';
function isRequestOriginEnabled() {
    return (process.env.OPENTELEMETRY_SERVER_ENABLED === 'true' ||
        process.env.NEXT_PUBLIC_OPENTELEMETRY_CLIENT_ENABLED === 'true' ||
        process.env.NEXT_PUBLIC_GRAPHQL_METRICS_ENABLED === 'true');
}
/**
 * Adds the tracing information to the request header.
 *
 * @param options The request options
 * @param apiOriginRequest API Request Origin information managed by the creator of the ApolloClient
 *
 * @author Adam Ayres
 */
function addTracingHeader(options, apiOriginRequest) {
    if (isRequestOriginEnabled()) {
        const { operations } = apiOriginRequest, remainingApiOriginRequest = __rest(apiOriginRequest, ["operations"]);
        const uniqueOperations = operations.filter((currentItem, index, updatedItems) => updatedItems.findIndex(matchedItem => (0, react_fast_compare_1.default)(matchedItem, currentItem)) === index);
        if (uniqueOperations.length > 0) {
            const apiOriginRequestWithDedupeComponentTracings = Object.assign(Object.assign({}, remainingApiOriginRequest), { operations: uniqueOperations });
            if (apiOriginRequestWithDedupeComponentTracings.pageName &&
                apiOriginRequestWithDedupeComponentTracings.path) {
                options.headers = Object.assign(Object.assign({}, options.headers), { [requestOriginHeader]: JSON.stringify(apiOriginRequestWithDedupeComponentTracings) });
            }
            else {
                log.debug('pageName or path missing from request: %O', apiOriginRequest);
            }
        }
    }
}
function updateLocationInformationOnApiOriginRequest(sourceOriginRequest, locationInformation) {
    const apiOriginRequest = Object.assign({}, sourceOriginRequest);
    apiOriginRequest.path = locationInformation.path;
    apiOriginRequest.fullUrl = locationInformation.fullUrl;
    apiOriginRequest.pageName = locationInformation.pageName;
    return apiOriginRequest;
}
//# sourceMappingURL=apolloTracingHelper.js.map